import { render, staticRenderFns } from "./ButtonHoverModule.vue?vue&type=template&id=c643fa46&scoped=true"
import script from "./ButtonHoverModule.vue?vue&type=script&lang=js"
export * from "./ButtonHoverModule.vue?vue&type=script&lang=js"
import style0 from "./ButtonHoverModule.vue?vue&type=style&index=0&id=c643fa46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c643fa46",
  null
  
)

export default component.exports